import { LOCALE_CHANGED } from './constants'

// eslint-disable-next-line
export function languageChanged(locale) {
    return (dispatch) => {
        dispatch({ type: LOCALE_CHANGED, payload: locale })
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/localized/actions.js